export default __webpack_public_path__ + "img/wikipedia.be2ca037a2d748a99cdba738cbccbfaa.svg";